let isCompanyInfoInit = false,
	isGroupsInit = false,
	isRegionsInit = false,
	isInsuranceInit = false,
	IsSafetyInit = false,
	profileTabs = null,
	uploadURL = '';

function InitViewProfile(renderInDialog) {
	if (!renderInDialog) {
		jQuery('head').append('<style>' + '#dnnslogan {background: none;} #sideMenu #menubox ul li {float: none;} #sideMenu #menubox ul li ul.level0 {left: 254px;top: 0px;} @media (max-width: 1319px) {#sideMenu {display: none;}} @media (min-width: 1320px) {#dnnmenu, #dnnheader .logo {display: none;} #dnnslogan {float:left;} #dnnslogan .row5 {min-width: 0;} #dnncontent {float:left;}}' + '</style>');
	}
	if (typeof renderInDialog === 'undefined' || renderInDialog === false) {
		PJQ.templating.TemplateRenderer.renderTemplate(false, new PJQ.templating.Template(PJQ.constants.modules.PROFILE_OLD, 'View', {
			isOldModule: true
		}), jQuery('#pjq-main'), null, function () {
			$('#dnnmenu').clone().attr('id', 'sideMenu').appendTo('#dnnslogan .row5');
			$('#dnnheader .logo').clone().removeClass('fleft').prependTo('#sideMenu');
		});
	}
	else {
		var dialog = jQuery('<div id="profileViewDialog"></div>');
		jQuery("#pjq-main").append(dialog);
		PJQ.templating.TemplateRenderer.renderTemplate(true, new PJQ.templating.Template(PJQ.constants.modules.PROFILE_OLD, 'View', {
			isOldModule: true
		}), dialog, null, function () {
			dialog.dialog({
				title: 'View Company Profile',
				modal: true,
				resizable: false,
				width: 800,
				close: function () {
					dialog.remove();
				},
				buttons: [{
					text: "Close",
					click: function () {
						jQuery(this).dialog('close');
						dialog.remove();
					}
				}]
			});
		});
	}

	profileTabs = jQuery('#mainProfileTabs');
	profileTabs.tabs();
	profileTabs.tabs("option", "active", 0);
	ShowProfile(false);
	profileTabs.on('tabsactivate', function (event, ui) {
		activeTab = profileTabs.tabs('option', 'active');
		if (activeTab == 1) {
			google.maps.event.trigger(companyLocationMap, 'resize');
			companyLocationMap.setCenter(companyLocationMapCenter);
		}
		else if (activeTab == 3) {
			google.maps.event.trigger(regionsMap, 'resize');
			regionsMap.setCenter(regionsMapCenter);
		}
		else if (activeTab == 5)
			UpdateSliderImages();
	});
	PanteraScript.PanteraScriptService.GetProfileSettings(pjqSessionId, pjqContactCompanyId, GetProfileSettingsC, onScriptError);
}

var sliderItemCount;
var sliderAnimate;
var sliderPause;
var profileSettings = null;
var hasInsurance = false;
var hasBonding = false;

function GetProfileSettingsC(response) {
	profileSettings = jQuery.parseJSON(response);
	if (profileSettings.LogoPath != null) {
		jQuery('.companyLogo').prepend("<div><img src='" + profileSettings.LogoPath + "'></div>");
	}
	else {
		jQuery('.companyLogo').remove();
	}

	//Profile Image
	var profileHeaderImagesContainer = jQuery('#profileHeaderImgs');
	if (profileSettings.DefaultHeaderImage !== '') {
		profileHeaderImagesContainer.append('<img src="images/profile/trade_' + profileSettings.DefaultHeaderImage + '.gif" />');
	}
	else {
		//Header Image Based on First group
		var imageName = "trade_01";
		if (profileSettings.Groups.length > 0 && profileSettings.Groups[0].GroupDescription.replace(/\D+/g, "").length > 0) {
			imageName = 'trade_' + profileSettings.Groups[0].GroupDescription.replace(/\D+/g, "");
		}
		if (imageName == "trade_01")
			imageName = "trade_01_" + Math.floor(Math.random() * 10).toString();
		//jQuery('#profileHeaderImgContainer').append('<img src="images/profile/' + imageName + '.png" />');
		profileHeaderImagesContainer.append('<img src="images/profile/' + imageName + '.gif" />');
	}

	//Company Tab
	jQuery('.companyName').html(profileSettings.CompanyName);
	jQuery('.businessName').html(profileSettings.BusinessName != null && profileSettings.BusinessName.length > 0 ? profileSettings.BusinessName : profileSettings.CompanyName);
	jQuery('#companyPhone').html(FormatPhoneHelper(profileSettings.PrimaryContactPhone));
	jQuery('#companyAddress').html(profileSettings.PrimaryContactAddress1 + " " + (profileSettings.PrimaryContactAddress2.length == 0 ? "" : (profileSettings.PrimaryContactAddress2 + " ")) + profileSettings.PrimaryContactCity + " " + profileSettings.PrimaryContactStateProvince + " " + profileSettings.PrimaryContactPostalCode);
	jQuery('#federalTaxId').html(profileSettings.FederalTaxId);
	jQuery('#companyWebsite').html(profileSettings.CompanyWebsite != null && profileSettings.CompanyWebsite.length > 0 ? ("<a href='" + profileSettings.CompanyWebsite + "'>" + profileSettings.CompanyWebsite + "</a>") : "N/A");
	jQuery('#companyFounded').html(profileSettings.CompanyFounded);
	jQuery('#stateOfFormation').html(profileSettings.StateOfFormation);
	jQuery('#companyType').html(profileSettings.CompanyType);
	jQuery('#otherBranches').html(profileSettings.HasOtherBranches ? "Yes" : "No");
	var completedProjectTypesString = '';
	if (profileSettings.CompletedProjectTypes != null && profileSettings.CompletedProjectTypes.length > 0) {
		var projectDataArr = profileSettings.CompletedProjectTypes.split(',');
		for (var ch = 0; ch < projectDataArr.length; ch++) {
			if (projectDataArr[ch].split('|')[0].length > 0) {
				completedProjectTypesString += projectDataArr[ch].split('|')[2] + ', ';
			}
		}
		if (completedProjectTypesString.length > 1)
			completedProjectTypesString = completedProjectTypesString.substr(0, completedProjectTypesString.length - 2);

	}
	else
		completedProjectTypesString = 'N/A';
	jQuery('#completedProjectTypes').html(completedProjectTypesString);

	var aboutusHeaderPlaceholderText = 'About Us';
	var aboutusHeaderPlaceholderText2 = 'More About Us';

	if (_.size(profileSettings.ProfileAboutLabel1) > 0)
		jQuery('#companyAboutHeader1 .contentText').html(profileSettings.ProfileAboutLabel1);
	else
		jQuery('#companyAboutHeader1 .contentText').html("About Us");
	if (_.size(profileSettings.ProfileAboutSection1) > 0)
		jQuery('#companyAbout1 .contentText').html(profileSettings.ProfileAboutSection1);
	//    else
	//        jQuery('#companyAbout1 .contentText').html(aboutUsEmptyMarkup);

	if (_.size(profileSettings.ProfileAboutLabel2) > 0)
		jQuery('#companyAboutHeader2 .contentText').html(profileSettings.ProfileAboutLabel2);
	else
		jQuery('#companyAboutHeader2 .contentText').html("More About Us");

	if (_.size(profileSettings.ProfileAboutSection2) > 0)
		jQuery('#companyAbout2 .contentText').html(profileSettings.ProfileAboutSection2);
	//    else
	//        jQuery('#companyAbout2 .contentText').html(aboutUsEmptyMarkup);

	//Contact Us Tab
	jQuery('#primaryContactName').html(profileSettings.PrimaryContactName);
	jQuery('#primaryContactAddress').html(profileSettings.PrimaryContactAddress1 + " " + (profileSettings.PrimaryContactAddress2.length == 0 ? "" : (profileSettings.PrimaryContactAddress2 + " ")) + profileSettings.PrimaryContactCity + " " + profileSettings.PrimaryContactStateProvince + " " + profileSettings.PrimaryContactPostalCode);
	jQuery('#primaryContactPhone').html(FormatPhoneHelper(profileSettings.PrimaryContactPhone));
	jQuery('#primaryContactFax').html(FormatPhoneHelper(profileSettings.PrimaryContactFax));
	jQuery('#primaryContactCity').html(profileSettings.PrimaryContactCity);
	jQuery('#primaryContactStateProvince').html(profileSettings.PrimaryContactStateProvince);
	jQuery('#primaryContactPostalCode').html(profileSettings.PrimaryContactPostalCode);
	jQuery('#primaryContactCountry').html(profileSettings.PrimaryContactCountry);
	InitCompanyLocationMap(profileSettings.CompanyName, profileSettings.Latitude, profileSettings.Longitude);
	InitRegionsHelper();
	PanteraScript.PanteraScriptService.GetGalleryPhotosForProfile(pjqContactCompanyId, InitPhotoGalleryHelper, onScriptError);
	//InitPhotoGallery(profileSettings.Images, true);
	//InitEditGalleryPhotos(profileSettings.Images);
	if (profileSettings.ProjectReferences != null)
		InitProjects(profileSettings.ProjectReferences);
	//Bonding/Insurance Tab
	hasBonding = false;
	hasInsurance = false;
	if (profileSettings.InsuranceTypeList != null && profileSettings.InsuranceTypeList.length > 0) {
		var insuranceArr = profileSettings.InsuranceTypeList.split(',');
		for (var i = 0; i < insuranceArr.length; i++) {
			if (insuranceArr[i].length > 0)
				jQuery('#insurance_' + insuranceArr[i].split('|')[0]).show().addClass('showInsurance');
			hasInsurance = true;
		}
		jQuery('#insuranceCoverage').find('div[id*="insurance"]').each(function () {
			if (!jQuery(this).hasClass('showInsurance'))
				jQuery(this).remove();
		});
		if (jQuery('#insuranceCoverage').find('div[id*="insurance"]').length == 0)
			jQuery('#insuranceCoverage').closest('td').remove();
	}
	else {
		jQuery('#insuranceCoverage').closest('td').remove();
	}

	if (profileSettings.IsBondable == null || !profileSettings.IsBondable) {
		jQuery('#isBondable').closest('td').remove();
	}
	else
		hasBonding = true;

	if (!hasInsurance && !hasBonding) {
		jQuery('#li-main-profile-bonding').hide();
	}
	else if (!hasInsurance && hasBonding) {
		jQuery('#li-main-profile-bonding').find('a').text('Bonding');
	}
	else if (hasInsurance && !hasBonding) {
		jQuery('#li-main-profile-bonding').find('a').text('Insurance');
	}
	else if (hasInsurance && hasBonding) {
		jQuery('#li-main-profile-bonding').find('a').text('Insurance/Bonding');
	}

	//Safety Tab
	if (profileSettings.HasSafetyDirector) {
		jQuery('#safetyDirector').show();
	}
	else {
		jQuery('#safetyDirector').remove();
	}
	if (profileSettings.HasSafetyProgram) {
		jQuery('#safetyProgram').show();
	}
	else {
		jQuery('#safetyProgram').remove();
	}
	if (profileSettings.HasSiteAudits) {
		jQuery('#siteAudits').show();
	}
	else {
		jQuery('#siteAudits').remove();
	}
	if (profileSettings.HasToolBoxTalks) {
		jQuery('#toolboxTalks').show();
	}
	else {
		jQuery('#toolboxTalks').remove();
	}
	if (profileSettings.HasTrainingProgram) {
		jQuery('#trainingProgram').show();
	}
	else {
		jQuery('#trainingProgram').remove();
	}
	if (profileSettings.HasDrugTesting) {
		jQuery('#drugTesting').show();
	}
	else {
		jQuery('#drugTesting').remove();
	}

	if (jQuery('#safetyItems').find('label').length == 0)
		jQuery('#safetyItems').hide();

	jQuery('.checkContainer span').addClass('ui-icon ui-icon-check');

	//Groups Tab
	if (profileSettings.Groups != null) {
		var groupCategories = [];
		for (var c = 0; c < profileSettings.Groups.length; c++) {
			if (groupCategories.indexOf(profileSettings.Groups[c].GroupDescription) == -1)
				groupCategories.push(profileSettings.Groups[c].GroupDescription);
		}
		var groupCategoryCounter = 0;
		for (var c = 0; c < groupCategories.length; c++) {
			jQuery('#companyGroupsContainer').append('<div class="outerGroupContainer" ><div style="width:100%;" class="profileTextHeader">' + groupCategories[c] + '</div><div class="innerGroupContainer" id="group_' + groupCategoryCounter + '"></div></div>');
			if (c == 0)
			//jQuery('#group_' + groupCategoryCounter).find('.groupCategoryHeader').addClass('noTopMargin');
				jQuery('#group_' + groupCategoryCounter).closest('.outerGroupContainer').addClass('noTopMargin');
			var thisFloat = 'left';
			for (var g = 0; g < profileSettings.Groups.length; g++) {
				if (groupCategories[c] == profileSettings.Groups[g].GroupDescription) {
					jQuery('#group_' + groupCategoryCounter).append('<div class="groupItem" style="width:50%;float:' + thisFloat + '"><span class="ui-icon ui-icon-triangle-1-e groupsIcon"></span>' + profileSettings.Groups[g].GroupName + '</div>');
					thisFloat == 'left' ? 'right' : 'left';
				}
			}
			jQuery('#group_' + groupCategoryCounter).append("<div style='clear:both'></div>");
			groupCategoryCounter++;
		}
	}

	//Network Icons
	if (profileSettings.IsDirectoryContact == true && profileSettings.IsNetworkContact == false) {
		//then show directory badge
		var directoryBadge = jQuery('<span class="editDirectoryContactStatus"><span class="directoryContactIcon"></span><span>Directory Network Member</span></span>');
		jQuery('#directoryNetworkIcons').append(directoryBadge);
	}
	else if (profileSettings.IsDirectoryContact == true && profileSettings.IsNetworkContact == true && profileSettings.NetworkVerificationLevel == 1) {
		//show icon/badge for qualified network 
		var qualifiedNetworkBadge = jQuery('<span class="editQualifiedNetworkContactStatus"><span class="networkContactPendingVerifiedIcon"></span><span>Qualified Network Member</span></span>');

		jQuery('#directoryNetworkIcons').append(qualifiedNetworkBadge);
	}
	else if (profileSettings.IsDirectoryContact == true && profileSettings.IsNetworkContact == true && profileSettings.NetworkVerificationLevel == 2) {
		//show icon/badge for verified network
		jQuery('#directoryNetworkIcons').append('<span class="editVerifiedNetworkContactStatus"><span class="networkContactVerifiedIcon"></span><span>Verified Network Member</span></span>');
	}

	ShowProfile(true);
}

var companyLocationMapCenter = null;
var companyLocationMap = null;

function InitCompanyLocationMap(companyName, latitude, longitude) {
	companyLocationMapCenter = new google.maps.LatLng(latitude, longitude);
	var companyLocationMapOptions = {
		zoom: 12,
		center: companyLocationMapCenter,
		mapTypeId: google.maps.MapTypeId.ROADMAP
	};

	companyLocationMap = new google.maps.Map(document.getElementById("companyLocationCanvas"), companyLocationMapOptions);

	var companyLocationMarker = new google.maps.Marker({
		position: companyLocationMapCenter,
		map: companyLocationMap,
		title: companyName
	});
}

function makeViewProjectPhotoClickhandler(photoId, projectReferenceId) {
	return function () {
		var dialog = jQuery('#viewProjectPhotoDialog');
		dialog.empty();
		var photoString = PJQ.helpers.urlHelpers.buildAPIURL("/profile/projectreferencephotos" + projectReferenceId + "/" + photoId +".png");
		dialog.append(photoString);

		dialog.dialog({
			title: 'View Project Photo',
			modal: true,
			resizable: false,
			dialogClass: 'viewProjectPhotoDialog',
			width: 800,
			close: function () {
			},
			buttons: [{
				text: "Close",
				click: function () {
					jQuery(this).dialog('close');
				}
			}]
		});
	}
}

function createProjectReferencePhotoDisplay(photos, projectReferenceId, projectPhotoContainer) {
	if (photos.length > 0) {
		//clear existing images
		projectPhotoContainer.empty();
		jQuery('#pjqProcessing').hide();
		for (var i = 0; i < photos.length; i++) {
			var thisImage = photos[i];
			var thisImageDom = jQuery("<div id='projectPhoto_" + thisImage.ProjectReferencePhotoId + "' class='photoThumbContainer'><img draggable='false' class='galleryPhotoThumb' src='/Profile/ProjectReferencePhotos/" +
				projectReferenceId + "/" + thisImage.ProjectReferencePhotoId + ".tn.png' style='max-width: 150px;max-height: 150px;'/></div>");

			thisImageDom.click(makeViewProjectPhotoClickhandler(thisImage.ProjectReferencePhotoId, projectReferenceId));
			projectPhotoContainer.append(thisImageDom);
		}
	}
}

function InitProjects(projects) {
	for (var i = 0; i < projects.length; i++) {
		if (projects[i].ProjectName.length > 0 && projects[i].DateCompleted.length > 0) {
			var thisProject = projects[i];
			var thisProjectDomId = 'project_' + thisProject.ProjectReferenceId.toString();
			jQuery('#allProjectsContainer').append(jQuery('.projectTemplate').contents().clone().attr('id', thisProjectDomId));
			var thisProjectDomObj = jQuery('#' + thisProjectDomId);
			thisProjectDomObj.find('.projectName').html(thisProject.ProjectName);
			thisProjectDomObj.find('.projectCompletion').html(thisProject.DateCompleted);
			thisProjectDomObj.find('.projectContractor').html(thisProject.GeneralContractor);

			var projectReferenceId = thisProject.ProjectReferenceId.toString();

			var thisProjectsPhotos = jQuery('.projectPhotos', thisProjectDomObj);
			createProjectReferencePhotoDisplay(thisProject.Photos, projectReferenceId, thisProjectsPhotos);
		}
	}
}

function InitRegionsHelper() {
	if (profileSettings.Regions != null && profileSettings.Regions.length > 0) {
		for (var r = 0; r < profileSettings.Regions.length; r++) {
			var thisRegion = profileSettings.Regions[r];
			var thisStateProvince = GetStateName(thisRegion.StateProvince);
			if (thisStateProvince != null || thisStateProvince.length > 0) {
				if (jQuery('#region_' + thisStateProvince).length == 0)
					jQuery('#regionsListContainer').append('<div class="regionListItem" id="region_' + thisStateProvince + '"><div class="regionParentRow">' + thisStateProvince + '<span class="ui-icon ui-icon-circlesmall-plus expandChildrenIcon"></span></div></div>');

				if (jQuery('#region_' + thisStateProvince).find('.regionChildren').length == 0)
					jQuery('#region_' + thisStateProvince).append('<div style="display:none;" class="regionChildren"></div>');

				var childrenContainer = jQuery('#region_' + thisStateProvince).find('.regionChildren');
				if (thisRegion.County.length == 0 && thisRegion.PostalCode.length > 0)
					childrenContainer.append('<div class="regionChildRow">Within ' + thisRegion.Radius + ' miles of Zip: ' + thisRegion.PostalCode + '</div>');
				else if (thisRegion.County.length > 0)
					childrenContainer.append('<div class="regionChildRow">' + thisRegion.County + ' County</div>');
				else if (thisRegion.County.length == 0 && thisRegion.PostalCode.length == 0) {
					jQuery('#region_' + thisStateProvince).find('.regionParentRow').html(jQuery('#region_' + thisStateProvince).find('.regionParentRow').html() + " (Whole State)");
					jQuery('#region_' + thisStateProvince).find('.expandChildrenIcon').hide();
				}
			}
		}
	}
	jQuery('.expandChildrenIcon').on('click', function () {
		if (jQuery(this).hasClass('ui-icon-circlesmall-plus')) {
			jQuery(this).removeClass('ui-icon-circlesmall-plus');
			jQuery(this).addClass('ui-icon-circlesmall-minus');
			jQuery(this).closest('.regionListItem').find('.regionChildren').slideDown();
		}
		else {
			jQuery(this).removeClass('ui-icon-circlesmall-minus');
			jQuery(this).addClass('ui-icon-circlesmall-plus');
			jQuery(this).closest('.regionListItem').find('.regionChildren').slideUp();
		}
	});
	InitRegionsMapView();
}

var regionsMapCenter = null;
var regionsMap = null;

function InitRegionsMapView() {
	regionsMapCenter = new google.maps.LatLng(43.0038, -115.8628);
	var regionsMapOptions = {
		zoom: 3,
		center: regionsMapCenter,
		mapTypeId: google.maps.MapTypeId.ROADMAP
	};
	regionsMap = new google.maps.Map(document.getElementById("regionsCanvas"), regionsMapOptions);
	CreateMapFusionLayersHelper(profileSettings.Regions);
}

function CreateMapFusionLayersHelper(regions) {
	var existingStateRegions = '';
	var existingZipRegions = '';
	var isState = false;
	if (stateFusionLayer != null) {
		stateFusionLayer.setMap(null);
	}
	if (zipFusionLayer != null) {
		zipFusionLayer.setMap(null);
	}
	if (zipCirclesLayers != null) {
		for (var zc = 0; zc < zipCirclesLayers.length; zc++) {
			zipCirclesLayers[zc].setMap(null);
		}
	}
	for (var sfl = 0; sfl < regions.length; sfl++) {
		var thisCity = 'null';
		var thisCounty = regions[sfl].County;
		var thisState = regions[sfl].StateProvince;
		var thisZip = regions[sfl].PostalCode;
		var thisRadius = regions[sfl].Radius;
		if (thisState.length > 0 && thisCounty.length == 0 && thisZip.length == 0) {
			isState = true;
			existingStateRegions += "'" + thisState + "',";
		}
		else if (thisCounty.length > 0) {
			PanteraScript.PanteraScriptService.GetZipCodeInfoByStateCountyCity(thisState, thisCounty, "", CreateMapZipFusionLayers, onScriptError);
		}
		else if (thisZip.length > 0) {
			PanteraScript.PanteraScriptService.GetLatLongInfoByZipCode(thisZip, parseInt(thisRadius), CreateMapZipCirclesLayers, onScriptError);
		}
	}
	if (isState) {
		existingStateRegions = existingStateRegions.substring(0, existingStateRegions.length - 1);
		CreateMapStateFusionLayers(existingStateRegions);
	}
}

var allStatesStr = 'AK,AL,AR,AS,AZ,CA,CO,CT,DE,DC,FL,GA,GU,HI,ID,IL,IN,IA,KS,KY,LA,ME,MP,MH,MD,MA,MI,MN,MS,MO,MT,NE,NV,NH,NJ,NM,NY,NC,ND,OH,OK,OR,PW,PA,PR,RI,SC,SD,TN,TX,UT,VT,VA,VI,WA,WV,WI,WY';
var allStatesArr = allStatesStr.split(',');
var allProvinceStr = 'AB,BC,MB,NB,NL,NT,NS,ON,PE,QC,SK,YT';
var allProvinceArray = allProvinceStr.split(',');
var stateFusionLayer = null;

function CreateMapStateFusionLayers(stateStringF) {
	if (stateStringF.length != 0) {
		var stateQuery;
		if (stateStringF == allStatesStr) {
			addAllStatesRegionsButton.button('disable');
			stateFusionLayer = new google.maps.FusionTablesLayer({
				query: {
					select: 'geometry',
					from: '17aT9Ud-YnGiXdXEJUyycH2ocUqreOeKGbzCkUw'
				}
			});
		}
		else {
			if (stateStringF.indexOf(',') != -1) {
				stateQuery = 'id in (' + stateStringF + ')';
			}
			else {
				stateQuery = 'id = ' + stateStringF;
			}
			stateFusionLayer = new google.maps.FusionTablesLayer({
				query: {
					select: 'geometry',
					from: '17aT9Ud-YnGiXdXEJUyycH2ocUqreOeKGbzCkUw',
					where: stateQuery
				}
			});
		}
		stateFusionLayer.setMap(regionsMap);
	}
}

var zipFusionLayer = null;

function CreateMapZipFusionLayers(zipStringF) {
	if (zipStringF.length != 0) {
		var zipQuery;
		if (zipStringF.indexOf(',') != -1) {
			zipQuery = 'ZIP in (' + zipStringF + ')';
		}
		else {
			zipQuery = 'ZIP = ' + zipStringF;
		}
		zipFusionLayer = new google.maps.FusionTablesLayer({
			query: {
				select: 'geometry',
				from: '1Lae-86jeUDLmA6-8APDDqazlTOy1GsTXh28DAkw',
				where: zipQuery
			}
		});
		zipFusionLayer.setMap(regionsMap);
	}
}

var zipCirclesLayers = [];

function CreateMapZipCirclesLayers(response) {
	var llResult = jQuery.parseJSON(response);
	var circleOpts = {
		strokeColor: '#FF0000',
		strokeOpacity: 0.8,
		strokeWeight: 2,
		fillColor: '#FF0000',
		fillOpacity: 0.35,
		map: regionsMap,
		center: new google.maps.LatLng(llResult.Latitude, llResult.Longitude),
		radius: llResult.Radius * 1609.344
	};
	var thisCircleArrayInd = zipCirclesLayers.length;
	zipCirclesLayers[thisCircleArrayInd] = new google.maps.Circle(circleOpts);
	zipCirclesLayers[thisCircleArrayInd].setMap(regionsMap);
}

function InitPhotoGalleryHelper(response) {
	InitPhotoGallery(jQuery.parseJSON(response), true);
}

var photoSlider = null;

function InitPhotoGallery(photos, isOnLoad) {
	jQuery('#photoGallery').remove();
	jQuery('#profileTabPhotoGallery').prepend('<div id="photoGallery"><ul class="slides"></ul></div>');
	if (!isOnLoad) {
		photos = jQuery.parseJSON(photos);
	}
	if (photos != null && photos.length > 0) {
		photoSlider = jQuery('#photoGallery');
		var imagePath;
		for (p = 0; p < photos.length; p++) {
			photoSlider.find('ul.slides').append("<li><img id='sliderImage_" + photos[p].UserImageId + "' src='" + profileSettings.UserImagePath + photos[p].UserImageId + ".png'></li>");
		}
		photoSlider.show();
		photoSlider.flexslider({
			animation: "slide",
			slideshow: true,
			controlNav: false,
			directionNav: false,
			pausePlay: false,
			itemMargin: 0
		});
	}
}

function UpdateSliderImages() {
	PanteraScript.PanteraScriptService.GetGalleryPhotosForProfile(pjqContactCompanyId, InitPhotoGallery, onScriptError);
}


var statesObj = [{
	name: 'ALABAMA',
	abbreviation: 'AL'
}, {
	name: 'ALASKA',
	abbreviation: 'AK'
}, {
	name: 'AMERICAN SAMOA',
	abbreviation: 'AS'
}, {
	name: 'ARIZONA',
	abbreviation: 'AZ'
}, {
	name: 'ARKANSAS',
	abbreviation: 'AR'
}, {
	name: 'CALIFORNIA',
	abbreviation: 'CA'
}, {
	name: 'COLORADO',
	abbreviation: 'CO'
}, {
	name: 'CONNECTICUT',
	abbreviation: 'CT'
}, {
	name: 'DELAWARE',
	abbreviation: 'DE'
}, {
	name: 'DISTRICT OF COLUMBIA',
	abbreviation: 'DC'
}, {
	name: 'FEDERATED STATES OF MICRONESIA',
	abbreviation: 'FM'
}, {
	name: 'FLORIDA',
	abbreviation: 'FL'
}, {
	name: 'GEORGIA',
	abbreviation: 'GA'
}, {
	name: 'GUAM',
	abbreviation: 'GU'
}, {
	name: 'HAWAII',
	abbreviation: 'HI'
}, {
	name: 'IDAHO',
	abbreviation: 'ID'
}, {
	name: 'ILLINOIS',
	abbreviation: 'IL'
}, {
	name: 'INDIANA',
	abbreviation: 'IN'
}, {
	name: 'IOWA',
	abbreviation: 'IA'
}, {
	name: 'KANSAS',
	abbreviation: 'KS'
}, {
	name: 'KENTUCKY',
	abbreviation: 'KY'
}, {
	name: 'LOUISIANA',
	abbreviation: 'LA'
}, {
	name: 'MAINE',
	abbreviation: 'ME'
}, {
	name: 'MARSHALL ISLANDS',
	abbreviation: 'MH'
}, {
	name: 'MARYLAND',
	abbreviation: 'MD'
}, {
	name: 'MASSACHUSETTS',
	abbreviation: 'MA'
}, {
	name: 'MICHIGAN',
	abbreviation: 'MI'
}, {
	name: 'MINNESOTA',
	abbreviation: 'MN'
}, {
	name: 'MISSISSIPPI',
	abbreviation: 'MS'
}, {
	name: 'MISSOURI',
	abbreviation: 'MO'
}, {
	name: 'MONTANA',
	abbreviation: 'MT'
}, {
	name: 'NEBRASKA',
	abbreviation: 'NE'
}, {
	name: 'NEVADA',
	abbreviation: 'NV'
}, {
	name: 'NEW HAMPSHIRE',
	abbreviation: 'NH'
}, {
	name: 'NEW JERSEY',
	abbreviation: 'NJ'
}, {
	name: 'NEW MEXICO',
	abbreviation: 'NM'
}, {
	name: 'NEW YORK',
	abbreviation: 'NY'
}, {
	name: 'NORTH CAROLINA',
	abbreviation: 'NC'
}, {
	name: 'NORTH DAKOTA',
	abbreviation: 'ND'
}, {
	name: 'NORTHERN MARIANA ISLANDS',
	abbreviation: 'MP'
}, {
	name: 'OHIO',
	abbreviation: 'OH'
}, {
	name: 'OKLAHOMA',
	abbreviation: 'OK'
}, {
	name: 'OREGON',
	abbreviation: 'OR'
}, {
	name: 'PALAU',
	abbreviation: 'PW'
}, {
	name: 'PENNSYLVANIA',
	abbreviation: 'PA'
}, {
	name: 'PUERTO RICO',
	abbreviation: 'PR'
}, {
	name: 'RHODE ISLAND',
	abbreviation: 'RI'
}, {
	name: 'SOUTH CAROLINA',
	abbreviation: 'SC'
}, {
	name: 'SOUTH DAKOTA',
	abbreviation: 'SD'
}, {
	name: 'TENNESSEE',
	abbreviation: 'TN'
}, {
	name: 'TEXAS',
	abbreviation: 'TX'
}, {
	name: 'UTAH',
	abbreviation: 'UT'
}, {
	name: 'VERMONT',
	abbreviation: 'VT'
}, {
	name: 'VIRGIN ISLANDS',
	abbreviation: 'VI'
}, {
	name: 'VIRGINIA',
	abbreviation: 'VA'
}, {
	name: 'WASHINGTON',
	abbreviation: 'WA'
}, {
	name: 'WEST VIRGINIA',
	abbreviation: 'WV'
}, {
	name: 'WISCONSIN',
	abbreviation: 'WI'
}, {
	name: 'WYOMING',
	abbreviation: 'WY'
}];

function GetStateName(input) {
	for (var i = 0; i < statesObj.length; i++) {
		if (statesObj[i].abbreviation.toLowerCase() == input.toLowerCase())
			return UppercaseFirstLetter(statesObj[i].name);
		else if (statesObj[i].name.toLowerCase() == input.toLowerCase())
			return UppercaseFirstLetter(statesObj[i].abbreviation);
	}
	return '';
}

function UppercaseFirstLetter(str) {
	return str.replace(/\w\S*/g, function (txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
	});
}


function ShowProfile(isShow) {
	if (isShow) {
		jQuery('#pjqLoading').hide();
		jQuery('#mainProfileTabs').show();

		//hide groups, regions, projects, and photo gallery
		if (profileSettings.Groups == null || profileSettings.Groups.length == 0) {
			jQuery('#li-main-profile-group').hide();
		}
		if (profileSettings.Regions == null || profileSettings.Regions.length == 0) {
			jQuery('#li-main-profile-regions').hide();
		}
		if (profileSettings.ProjectReferences == null || profileSettings.ProjectReferences.length == 0) {
			jQuery('#li-main-profile-projects').hide();
		}
		if (profileSettings.Images == null || profileSettings.Images.length == 0) {
			jQuery('#li-main-profile-photo-gallery').hide();
		}

		if (jQuery('#safetyItems').find('label').length > 0 && (hasInsurance || hasBonding)) {
			jQuery('#insuranceContainer').addClass('floatLeft50');
			jQuery('#safetyContainer').addClass('floatRight50');
			jQuery('#safetyContainer').after('<div style="clear:both;"></div>');
			if (jQuery('#safetyContainer .contentDiv').height() > jQuery('#insuranceContainer .contentDiv').height())
				jQuery('#insuranceContainer .contentDiv').height(jQuery('#safetyContainer .contentDiv').height());
			else
				jQuery('#safetyContainer .contentDiv').height(jQuery('#insuranceContainer .contentDiv').height());
			jQuery('#safetyContainer .profileTextHeader').css('margin-top', '5px');
		}
	}
	else {
		jQuery('#mainProfileTabs').hide();
		jQuery('#pjqLoading').show();
	}
}